export default __webpack_public_path__ + "static/media/twitter.aee43aa5.svg";